import { useEffect, useRef } from 'react';

/**
 * Calls a callback every time a value changes. Will not call the callback on first render.
 */
export function useOnChange<T>(
	value: T,
	effect: (p: T, c: T) => void | (() => void),
	isEqual = (p: T, c: T) => p === c
) {
	const prevValue = useRef(value);

	useEffect(
		() => {
			const tmp = prevValue.current;
			prevValue.current = value;
			if (!isEqual(tmp, value)) {
				return effect(tmp, value);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[value]
	);
}
